import { default as TechnologyView } from './TechnologyView';
import { default as CrewView } from './CrewView';
import { default as DestinationRoute } from './DestinationView';
import { default as HomeRoute } from './HomeView';

const routes = [TechnologyView, CrewView, DestinationRoute, HomeRoute];

export default routes;
